<template>
  <div class="page-wrap text-center">
    <div
      class="session-form-hold d-flex flex-column flex-md-row gap-8 align-center justify-center"
    >
      <div>
        <v-card
          :loading="true"
          class="rounded-xl mx-0"
          style="max-width: 400px"
        >
          <party-cover-video
            :party="party"
            :loading="pageLoading"
            rounded="rounded-t-xl"
            noEffect
          />

          <v-card-text>
            <h5>Esse evento está com muitos acessos</h5>
            <h6>Você está na fila para acessar o evento</h6>
            <div style="width: 100%; height: 30px; position: relative">
              <v-progress-linear
                height="30"
                class="rounded-l-lg rounded-r"
                :buffer-value="position"
                :value="position"
                stream
              >
              </v-progress-linear>
              <img
                src="/img/walk.gif"
                width="30"
                height="34"
                class="flip-horizontal"
                :class="{ 'invert-color': $vuetify.theme.dark }"
                style="position: absolute; top: -2px"
                :style="{ left: `calc(${position}% - 15px)` }"
              />
            </div>
            <p v-if="queue.position > 15">
              Você está em {{ queue.position }}° na fila
            </p>
            <p v-else-if="queue.position > 5">
              Sua vez está chegando, fique atento
            </p>
            <p v-else>Você é o próximo na fila</p>
            <v-divider class="my-4" />
            <div outlined>
              <v-alert
                v-if="!user"
                type="warning"
                dense
                text
                class="text-left"
                @click="$root.$emit('require-sign-in')"
              >
                Para que você possa realizar uma compra, você precisará estar
                logado.
                <small class="d-block">
                  Clique aqui para acessar sua conta
                </small>
              </v-alert>
              <v-list class="text-left">
                <v-list-item>
                  <v-icon left>mdi-clock</v-icon>
                  Na sua vez, você terá 10 minutos para realizar uma compra.
                </v-list-item>
                <v-list-item>
                  <v-icon left>mdi-lock</v-icon>
                  Não feche ou atualize a página. Na sua vez, ela será
                  atualizada automaticamente.
                </v-list-item>
              </v-list>
            </div>

            <v-switch
              v-model="playbeep"
              label="Tocar alerta de quando for minha vez"
              hide-details
              class="pa-0"
              dense
            />
          </v-card-text>
          <v-card-actions class="flex-column">
            <v-btn color="error" @click="exitQueue" text small block>
              Sair da fila
            </v-btn>
          </v-card-actions>
        </v-card>
        <div class="pt-2">
          <small class="secondary--text">{{ queue.id }}</small>
        </div>
      </div>
      <div v-if="party.spotifyId" class="pa-2 pb-1" rounded="xl">
        <h6 class="font-weight-bold white--text">Entre no clima do evento</h6>
        <spotify-embed :id="party.spotifyId" />
      </div>
    </div>
    <require-sign-in v-if="!user" @success="successSign" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import QUEUE from "@/services/queue";
import SpotifyEmbed from "@/components/global/SpotifyEmbed.vue";
import PartyCoverVideo from "@/components/shop/PartyCoverVideo.vue";
import RequireSignIn from "@/components/shop/modal/RequireSignIn.vue";
import ProtectUnload from "@/utils/ProtectUnload";

export default {
  name: "QueueParty",
  metaInfo: {
    title: "Fila de Acesso",
  },
  components: {
    SpotifyEmbed,
    PartyCoverVideo,
    RequireSignIn,
  },
  data() {
    return {
      pageLoading: true,
      queue: null,
      party: null,
      timeout: null,
      playbeep: false,
      minPosition: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),

    position() {
      const initialPosition = this.queue?.initialPosition || 1;
      const position = this.minPosition || this.queue?.position || 0;
      return ((initialPosition - position) / initialPosition) * 100;
    },
  },
  methods: {
    async checkQueue() {
      try {
        clearTimeout(this.timeout);
        const queue = await QUEUE.evolution(this.queue.token);
        const queueData = Object.assign(this.queue, queue);
        window.sessionStorage.setItem("queue", JSON.stringify(queueData));
        this.minPosition = Math.min(this.minPosition, queue.position);

        if (queue.status !== "waiting") {
          if (this.playbeep) await this.playBeep();
          ProtectUnload.off();
          this.$router.push({
            name: "shop.party",
            params: {
              partyId: this.$route.params.partyId,
              orgSlug: this.$route.params.orgSlug,
            },
          });
          return;
        }

        this.queue = queueData;
      } catch (error) {
        console.error(error);
      } finally {
        this.timeout = setTimeout(() => this.checkQueue(), 20000);
      }
    },
    async exitQueue() {
      try {
        const confirm = window.confirm("Tem certeza que deseja sair da fila?");
        if (!confirm) return;

        await QUEUE.exit(this.queue.token).catch((e) => {
          console.error(e);
        });
        window.sessionStorage.removeItem("queue");
        ProtectUnload.off();
        this.$router.push("/");
      } catch (error) {
        console.error(error);
      }
    },
    successSign() {
      this.pageLoading = false;
    },
    async playBeep() {
      const audio = new Audio("/beeps/queue.mp3");
      audio.play();
    },
  },
  watch: {
    playbeep() {
      if (this.playbeep) this.playBeep();
    },
  },

  created() {
    const queueData = window.sessionStorage.getItem("queue");
    if (!queueData) {
      this.$router.push({
        name: "shop.party",
        params: {
          partyId: this.$route.params.partyId,
          orgSlug: this.$route.params.orgSlug,
        },
      });
    }
    this.queue = JSON.parse(queueData);
    this.party = this.queue.party;
    this.pageLoading = false;
    ProtectUnload.on();
  },
  mounted() {
    this.checkQueue();
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  background: radial-gradient(
      circle at 50% 50%,
      rgba(0, 0, 0, 50%) 0%,
      rgba(0, 0, 0, 90%) 90vw
    ),
    url(/img/logo/auth-background.png), black;
  display: flex;
  background-size: cover;
  background-position: center;
  align-items: center;
  padding: 40px 1rem;
  height: 100%;
  min-height: 100vh;
}

.session-form-hold {
  width: 100%;
}

.flip-horizontal {
  transform: scaleX(-1);
}

.invert-color {
  filter: invert(100%);
}
</style>
